import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as dom from '../../../base/browser/dom.js';
import { CaseSensitiveCheckbox, RegexCheckbox, WholeWordsCheckbox } from '../../../base/browser/ui/findinput/findInputCheckboxes.js';
import { Widget } from '../../../base/browser/ui/widget.js';
import { RunOnceScheduler } from '../../../base/common/async.js';
import { FIND_IDS } from './findModel.js';
import { contrastBorder, editorWidgetBackground, inputActiveOptionBorder, inputActiveOptionBackground, widgetShadow, editorWidgetForeground, inputActiveOptionForeground } from '../../../platform/theme/common/colorRegistry.js';
import { registerThemingParticipant } from '../../../platform/theme/common/themeService.js';
export var FindOptionsWidget = /*#__PURE__*/function (_Widget) {
  _inherits(FindOptionsWidget, _Widget);

  var _super = _createSuper(FindOptionsWidget);

  function FindOptionsWidget(editor, state, keybindingService, themeService) {
    var _this;

    _classCallCheck(this, FindOptionsWidget);

    _this = _super.call(this);
    _this._hideSoon = _this._register(new RunOnceScheduler(function () {
      return _this._hide();
    }, 2000));
    _this._isVisible = false;
    _this._editor = editor;
    _this._state = state;
    _this._keybindingService = keybindingService;
    _this._domNode = document.createElement('div');
    _this._domNode.className = 'findOptionsWidget';
    _this._domNode.style.display = 'none';
    _this._domNode.style.top = '10px';

    _this._domNode.setAttribute('role', 'presentation');

    _this._domNode.setAttribute('aria-hidden', 'true');

    var inputActiveOptionBorderColor = themeService.getColorTheme().getColor(inputActiveOptionBorder);
    var inputActiveOptionForegroundColor = themeService.getColorTheme().getColor(inputActiveOptionForeground);
    var inputActiveOptionBackgroundColor = themeService.getColorTheme().getColor(inputActiveOptionBackground);
    _this.caseSensitive = _this._register(new CaseSensitiveCheckbox({
      appendTitle: _this._keybindingLabelFor(FIND_IDS.ToggleCaseSensitiveCommand),
      isChecked: _this._state.matchCase,
      inputActiveOptionBorder: inputActiveOptionBorderColor,
      inputActiveOptionForeground: inputActiveOptionForegroundColor,
      inputActiveOptionBackground: inputActiveOptionBackgroundColor
    }));

    _this._domNode.appendChild(_this.caseSensitive.domNode);

    _this._register(_this.caseSensitive.onChange(function () {
      _this._state.change({
        matchCase: _this.caseSensitive.checked
      }, false);
    }));

    _this.wholeWords = _this._register(new WholeWordsCheckbox({
      appendTitle: _this._keybindingLabelFor(FIND_IDS.ToggleWholeWordCommand),
      isChecked: _this._state.wholeWord,
      inputActiveOptionBorder: inputActiveOptionBorderColor,
      inputActiveOptionForeground: inputActiveOptionForegroundColor,
      inputActiveOptionBackground: inputActiveOptionBackgroundColor
    }));

    _this._domNode.appendChild(_this.wholeWords.domNode);

    _this._register(_this.wholeWords.onChange(function () {
      _this._state.change({
        wholeWord: _this.wholeWords.checked
      }, false);
    }));

    _this.regex = _this._register(new RegexCheckbox({
      appendTitle: _this._keybindingLabelFor(FIND_IDS.ToggleRegexCommand),
      isChecked: _this._state.isRegex,
      inputActiveOptionBorder: inputActiveOptionBorderColor,
      inputActiveOptionForeground: inputActiveOptionForegroundColor,
      inputActiveOptionBackground: inputActiveOptionBackgroundColor
    }));

    _this._domNode.appendChild(_this.regex.domNode);

    _this._register(_this.regex.onChange(function () {
      _this._state.change({
        isRegex: _this.regex.checked
      }, false);
    }));

    _this._editor.addOverlayWidget(_assertThisInitialized(_this));

    _this._register(_this._state.onFindReplaceStateChange(function (e) {
      var somethingChanged = false;

      if (e.isRegex) {
        _this.regex.checked = _this._state.isRegex;
        somethingChanged = true;
      }

      if (e.wholeWord) {
        _this.wholeWords.checked = _this._state.wholeWord;
        somethingChanged = true;
      }

      if (e.matchCase) {
        _this.caseSensitive.checked = _this._state.matchCase;
        somethingChanged = true;
      }

      if (!_this._state.isRevealed && somethingChanged) {
        _this._revealTemporarily();
      }
    }));

    _this._register(dom.addDisposableNonBubblingMouseOutListener(_this._domNode, function (e) {
      return _this._onMouseOut();
    }));

    _this._register(dom.addDisposableListener(_this._domNode, 'mouseover', function (e) {
      return _this._onMouseOver();
    }));

    _this._applyTheme(themeService.getColorTheme());

    _this._register(themeService.onDidColorThemeChange(_this._applyTheme.bind(_assertThisInitialized(_this))));

    return _this;
  }

  _createClass(FindOptionsWidget, [{
    key: "_keybindingLabelFor",
    value: function _keybindingLabelFor(actionId) {
      var kb = this._keybindingService.lookupKeybinding(actionId);

      if (!kb) {
        return '';
      }

      return " (".concat(kb.getLabel(), ")");
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._editor.removeOverlayWidget(this);

      _get(_getPrototypeOf(FindOptionsWidget.prototype), "dispose", this).call(this);
    } // ----- IOverlayWidget API

  }, {
    key: "getId",
    value: function getId() {
      return FindOptionsWidget.ID;
    }
  }, {
    key: "getDomNode",
    value: function getDomNode() {
      return this._domNode;
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      return {
        preference: 0
        /* TOP_RIGHT_CORNER */

      };
    }
  }, {
    key: "highlightFindOptions",
    value: function highlightFindOptions() {
      this._revealTemporarily();
    }
  }, {
    key: "_revealTemporarily",
    value: function _revealTemporarily() {
      this._show();

      this._hideSoon.schedule();
    }
  }, {
    key: "_onMouseOut",
    value: function _onMouseOut() {
      this._hideSoon.schedule();
    }
  }, {
    key: "_onMouseOver",
    value: function _onMouseOver() {
      this._hideSoon.cancel();
    }
  }, {
    key: "_show",
    value: function _show() {
      if (this._isVisible) {
        return;
      }

      this._isVisible = true;
      this._domNode.style.display = 'block';
    }
  }, {
    key: "_hide",
    value: function _hide() {
      if (!this._isVisible) {
        return;
      }

      this._isVisible = false;
      this._domNode.style.display = 'none';
    }
  }, {
    key: "_applyTheme",
    value: function _applyTheme(theme) {
      var inputStyles = {
        inputActiveOptionBorder: theme.getColor(inputActiveOptionBorder),
        inputActiveOptionForeground: theme.getColor(inputActiveOptionForeground),
        inputActiveOptionBackground: theme.getColor(inputActiveOptionBackground)
      };
      this.caseSensitive.style(inputStyles);
      this.wholeWords.style(inputStyles);
      this.regex.style(inputStyles);
    }
  }]);

  return FindOptionsWidget;
}(Widget);
FindOptionsWidget.ID = 'editor.contrib.findOptionsWidget';
registerThemingParticipant(function (theme, collector) {
  var widgetBackground = theme.getColor(editorWidgetBackground);

  if (widgetBackground) {
    collector.addRule(".monaco-editor .findOptionsWidget { background-color: ".concat(widgetBackground, "; }"));
  }

  var widgetForeground = theme.getColor(editorWidgetForeground);

  if (widgetForeground) {
    collector.addRule(".monaco-editor .findOptionsWidget { color: ".concat(widgetForeground, "; }"));
  }

  var widgetShadowColor = theme.getColor(widgetShadow);

  if (widgetShadowColor) {
    collector.addRule(".monaco-editor .findOptionsWidget { box-shadow: 0 2px 8px ".concat(widgetShadowColor, "; }"));
  }

  var hcBorder = theme.getColor(contrastBorder);

  if (hcBorder) {
    collector.addRule(".monaco-editor .findOptionsWidget { border: 2px solid ".concat(hcBorder, "; }"));
  }
});